import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "store-group-mud-panel form-container panel-box" },
    [
      _c("span", { staticClass: "form-header mb-3" }, [
        _vm._v(_vm._s(_vm.$tkey("panelTitle"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-center mb-3 mt-2" },
        [
          _c(
            "span",
            { staticClass: "offset-type-label font-weight-600 mr-3" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$tkey("relative")) +
                  "\n      " +
                  _vm._s(_vm.$t("general.percentSymbol")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(VSwitch, {
            staticClass: "ma-0",
            attrs: { "input-value": _vm.isAbsolute, "hide-details": "" },
            on: { change: _vm.onOffsetTypeChange },
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "offset-type-label font-weight-600 ml-3" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$tkey("absolute")) +
                  "\n      " +
                  _vm._s(_vm.$t("clientCurrencySymbol")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            VTooltip,
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        VIcon,
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "info-icon ml-2",
                              attrs: { small: "" },
                            },
                            "v-icon",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [_vm._v("mdi-information-outline")]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.isRelative
                      ? _vm.$tkey("relativeOffsetHint")
                      : _vm.$tkey("absoluteOffsetHint")
                  )
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VRow,
        {
          staticClass: "mud-row",
          attrs: { align: "center", "no-gutters": "" },
        },
        [
          _c(
            VCol,
            { staticClass: "mud-input", attrs: { cols: "12", md: "auto" } },
            [
              _c(VTextField, {
                staticClass: "max-up-down-input",
                attrs: {
                  label: _vm.$t(
                    "settings.penaltyRules.storeGroupMaxUpDown.maxUp"
                  ),
                  type: "text",
                  flat: "",
                  "background-color": _vm.owWhite,
                  suffix: _vm.unitLabel,
                  "error-messages": _vm.maxUpDown.applyMaxUp
                    ? _vm.validationErrors.maxUpValue
                    : [],
                  disabled: !_vm.maxUpDown.applyMaxUp,
                },
                on: {
                  keypress: function ($event) {
                    return _vm.ensureDecimal($event, true)
                  },
                  paste: function ($event) {
                    return _vm.ensurePastedDecimal($event, true)
                  },
                },
                model: {
                  value: _vm.maxUpDisplay,
                  callback: function ($$v) {
                    _vm.maxUpDisplay = $$v
                  },
                  expression: "maxUpDisplay",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VCol,
            { staticClass: "mud-control", attrs: { cols: "12", md: "auto" } },
            [
              _c(VCheckbox, {
                staticClass: "pa-0 ma-0",
                attrs: { label: _vm.$t("settings.penaltyRules.Active") },
                model: {
                  value: _vm.applyMaxUp,
                  callback: function ($$v) {
                    _vm.applyMaxUp = $$v
                  },
                  expression: "applyMaxUp",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VRow,
        {
          staticClass: "mud-row",
          attrs: { align: "center", "no-gutters": "" },
        },
        [
          _c(
            VCol,
            { staticClass: "mud-input", attrs: { cols: "12", md: "auto" } },
            [
              _c(VTextField, {
                staticClass: "max-up-down-input",
                attrs: {
                  label: _vm.$t(
                    "settings.penaltyRules.storeGroupMaxUpDown.maxDown"
                  ),
                  type: "text",
                  flat: "",
                  "background-color": _vm.owWhite,
                  suffix: _vm.unitLabel,
                  "error-messages": _vm.maxUpDown.applyMaxDown
                    ? _vm.validationErrors.maxDownValue
                    : [],
                  disabled: !_vm.maxUpDown.applyMaxDown,
                },
                on: {
                  keypress: function ($event) {
                    return _vm.ensureDecimal($event, true)
                  },
                  paste: function ($event) {
                    return _vm.ensurePastedDecimal($event, true)
                  },
                },
                model: {
                  value: _vm.maxDownDisplay,
                  callback: function ($$v) {
                    _vm.maxDownDisplay = $$v
                  },
                  expression: "maxDownDisplay",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VCol,
            { staticClass: "mud-control", attrs: { cols: "12", md: "auto" } },
            [
              _c(VCheckbox, {
                staticClass: "pa-0 ma-0",
                attrs: { label: _vm.$t("settings.penaltyRules.Active") },
                model: {
                  value: _vm.applyMaxDown,
                  callback: function ($$v) {
                    _vm.applyMaxDown = $$v
                  },
                  expression: "applyMaxDown",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.validationErrors.maxUpDownDirection
        ? _c("div", { staticClass: "d-flex flex-column mt-2" }, [
            _c("span", { staticClass: "validation-fail pl-2" }, [
              _vm._v(_vm._s(_vm.validationErrors.maxUpDownDirection)),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }